import React, { useEffect, useState } from 'react';
import { CodeIcon } from '@heroicons/react/solid';

function Analytics() {
  const [pageViews, setPageViews] = useState(null); // Start with null for loading state
  const [error, setError] = useState(null); // State to handle errors

  useEffect(() => {
    const updateCount = async () => {
      const apiUrl = `https://api.counterapi.dev/v1/${process.env.REACT_APP_MY_COUNTER_NAMESPACE}/visits/up`;

      try {
        // Fetch the new page view count using the updated endpoint
        const response = await fetch(apiUrl);

        // Check if the response is ok (status 200-299)
        if (!response.ok) {
          throw new Error(`API error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        // Update the page views if the response contains a count value
        if (data.count) {
          setPageViews(data.count);
        } else {
          throw new Error("No count value received from the API");
        }

      } catch (error) {
        // Set the error message to be displayed
        setError(error.message);
        console.error("Error fetching page views:", error);
      }
    };

    updateCount(); // Fetch and update the page view count
  }, []); // Empty dependency array to ensure this effect runs once on mount

  return (
    <div className="container px-5 py-10 mx-auto text-center lg:px-40">
      <div className="flex flex-col mb-20">
        <CodeIcon className="mx-auto inline-block w-10 mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium text-white mb-4">
          Visitor Analytics
        </h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base p-4">
          I utilized the fetch method in JavaScript and the
          secure dotenv methodology to keep track of page views in real-time.
          The counter is implemented directly in the 'Analytics.js' file using the `process.env` method to access the environment variable. The data for this tool is only available for the year 2023, and all queries are filtered accordingly.
          It's a perfect solution for anyone looking to optimize user experience, track performance, and enhance their online presence. Take a look at{" "}
          <a href="https://api.counterapi.dev/" className="text-pink-600 font-bold">
            counterapi.dev
          </a>{" "}
          to see how it works and feel free to reach out to me for more details
          on this <a href="#project">project</a>. If you see it stuck loading, it means it is a "504 external error",{" "} 
          where we need to wait for the API developer to fix their server.
        </p>
      </div>

      {error ? (
        <div className="bg-red-600 text-white p-4 rounded">
          <p>Error: {error}</p> {/* Display error message */}
        </div>
      ) : (
        <div className="flex items-center justify-center h-24 w-24 rounded-full bg-gray-600 mx-auto mb-10">
          {pageViews === null ? (
            <p className="text-4xl text-white font-bold animate-pulse">
              Loading...
            </p>
          ) : (
            <p className="text-4xl font-bold text-pink-500">{pageViews}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/Analytics.js